import { createFormHook } from "@tanstack/react-form";

import {
  AutocompleteField,
  DatePickerField,
  PasswordField,
  SelectField,
  SwitchField,
  TextFieldComponent,
  TextFieldMantine,
} from "./FormField";
import { fieldContext, formContext } from "./formContexts";

// Create the enhanced form hook with all field components
const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    AutocompleteField,
    DatePickerField,
    PasswordField,
    SelectField,
    TextFieldComponent,
    TextFieldMantine,
    SwitchField,
  },
  formComponents: {},
});

export { useAppForm, withForm };
